import React, { useEffect } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FY25_26_ReturnsFile from "../static/FY25_26_Returns.pdf";

export default function FY2526Returns() {
    useEffect(() => {
        const returns2526View = document.getElementById('FY25_26_Returns');
        if (returns2526View) {
            returns2526View.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    return (
        <Container id="FY25_26_Returns" sx={{
            my: { sm: 0, xs: 5 },
            py: { sm: 16, xs: 12 }
        }} fixed>
            <Box sx={{ minHeight: '50vh' }}>
                <>
                    <Typography variant="h1" component="h1" align="center">
                        Annual returns FY 25_26
                    </Typography>
                    <br />
                </>
                <br />
                <>
                    <Typography variant="h6" component="h1" align="left">
                        Our Annual filling(MGT-7A) with MCA portal for Financial year 2025 - 2026
                        <br /><br />
                    </Typography>
                    <Box textAlign="center">
                        <embed style={{ minHeight: '1200px', minWidth: '800px' }} src={FY25_26_ReturnsFile} width="100%" height="100%" type="application/pdf" />
                    </Box>
                </>
            </Box>
        </Container>
    );
}